import { coreUtils } from '@wix/santa-ds-libs/basic';

export const fontUtils = coreUtils.fontUtils.createFontUtils(true);
